import { API_BASE_URL } from '../config/api'

export const getMediaUrl = (mediaItem) => {
  return `${API_BASE_URL}${mediaItem.path}`
}

export const isVideo = (mimetype) => {
  return mimetype.startsWith('video/')
}

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}